import React, { Component } from 'react'
import { Button, Icon, Popconfirm, Spin, Table } from 'antd'
import moment from 'moment'
// import agentPayments from '@services/agentPayments'
import { agentPayments, files, commissions } from '@services/api'
import download from '@utils/download'
import { fileExt } from '@texts/files'

class Files extends Component<any> {
    constructor (props) {
        super(props)
        this.state = {
            page: 1,
            showUpdateCol: null,
            lastPayment: '',
            loadingId: ''
        }
    }

    publishPayments = (payload) => {
        return agentPayments.publishPayments(payload)
    }

    downloadFile = async file => {
        let arrUrl = file.url.split('/')
        let nullIndex = arrUrl.indexOf('null')
        if (nullIndex > -1) arrUrl.splice(nullIndex, 1)
        let url = arrUrl.join('/')

        const downloadedFile = await files
            .assert(url)
            .then(res => new Blob([res.data], { type: fileExt[file.file_ext] }))
        download(downloadedFile, file.file_name)
    }

    updateAgents = (record) => {
        this.setState({ showUpdateCol: null })

        commissions.updateAgents({ id: record.id, file_name: record.file_name })
        .then(() => {
            alert('עדכון נשלח בהצלחה')
        })
        .catch(() => {
            alert('אירעה שגיאה. עדכון לא נשלח')
        })
    }

    columns = [
        {
            title: 'הורדה',
            key: 'download',
            width: 200,
            align: 'right',
            render: (_, record) => <Button onClick={() => this.downloadFile(record)}>הורד קובץ</Button>
        },
        {
            title: 'נוצר בתאריך',
            key: 'created_at',
            align: 'right',
            render: (_, record) => (
                <div>
                    {record.created_at ? moment(record.created_at).format('HH:mm DD/MM/YY') : 'אין תאריך העלאה'}
                </div>
            )
        },
        {
            title: 'שם הקובץ',
            key: 'file_name',
            align: 'right',
            render: (_, record) => <div>{record.file_name}</div>
        },
        {
            title: 'מזהה',
            key: 'id',
            align: 'right',
            render: (_, record) => <div>{record.id}</div>
        },
        {
            title: 'סיומת',
            key: 'file_ext',
            align: 'right',
            render: (_, record) => <div>{record.file_ext}</div>
        },
        {
            title: '',
            key: 'update',
            align: 'right',
            render: (_, record) => {

                        const { showUpdateCol } = this.state

                        let date = new Date()
                        let name = record.file_name.split('.')[0]
                        let [month, year] = name.split('-')

                        if (date.getMonth() == month - 1 && date.getFullYear() == year) {
                            return ''
                        } else if (showUpdateCol === null) {
                            return <Button onClick={() => this.setState({ showUpdateCol: record.id })}>עדכון סוכנים</Button>
                        } else if (showUpdateCol == record.id) {
                            return (
                                <div style={{ ...style.column }}>
                                    <span>?האם את/ה בטוח/ה</span>
                                    <div style={{ display: 'flex' }}>
                                        <Button onClick={() => this.updateAgents(record)}>כן</Button>
                                        <Button onClick={() => this.setState({ showUpdateCol: null })}>לא</Button>
                                    </div>
                                </div>
                            )
                        }
                    }
        },

        {
            title: 'גלוי',
            key: 'hide',
            align: 'right',
            render: (_, record) => {

                const { loadingId } = this.state
                const { lastPayment } = this.props
                const [recordMonth, recordYear] = record.file_name.split('.')[0].split('-')
                let lastPaymentDate = new Date(lastPayment.year, lastPayment.month >= 1 ? lastPayment.month - 1 : 11).getTime()
                let recordDate = new Date(recordYear, recordMonth >= 1 ? recordMonth -1 : 11).getTime()
                let hide = recordDate > lastPaymentDate ? true : false
                let currentMonth = new Date().getMonth()
                let currentYear = new Date().getFullYear()
                let testFile = currentYear == recordYear && currentMonth + 1 == recordMonth

                if (testFile) {
                    return ''
                } else if (hide) {

                    const handle = () => {
                        this.setState({ loadingId: record.id }, () => {
                            this.publishPayments({ year: recordYear, month:  recordMonth })
                            .then(() => {
                                this.props.getLastPayment()
                                this.setState({ loadingId: '' })
                            })
                        })
                    }

                    return loadingId == record.id ? (
                        <Spin />
                    ) : (
                        <div style={{ display: 'flex' }}>
                            <Icon type='close' style={{ color: 'red', fontSize: '16px' }} />
                            <Popconfirm
                                    onConfirm={handle}
                                    title='האם את/ה בטוח/ה?'
                                    cancelText='ביטול'
                                    okText='אישור'
                                    >
                                    <div
                                        style={{ margin: '-7px 10px 0 0', cursor: 'pointer', textDecoration: 'underline' }}
                                    >
                                        {"פרסום"}
                                    </div>
                            </Popconfirm>
                        </div>
                    )
                } else {
                    return <Icon style={{ color: 'green', fontSize: '16px' }} type='check' />
                }
            }
        }
    ]

    render() {
        const { list, loading } = this.props
        const { page } = this.state
        const pageSize = 7
        return (
            <div>
                <Button icon="reload" onClick={this.props.getCommissionFile} style={{ marginBottom: '0.8rem' }} />
                <Table
                    className="center-table"
                    style={{ width: '100%' }}
                    rowKey="id"
                    loading={loading}
                    columns={this.columns}
                    rowClassName={record => record.policy_id}
                    dataSource={list.slice((page - 1) * pageSize, page * pageSize)}
                    pagination={{
                        total: list.length,
                        pageSize: pageSize,
                        current: page,
                        hideOnSinglePage: true,
                        onChange: page => this.setState({ page })
                    }}
                />
            </div>
        )
    }
}

const style = {
    column: {
        display: 'flex',
        flexDirection: 'column'
    }
}

export default Files
